"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditTrail = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cn_1 = require("cn");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const audit_1 = require("../../api-clients/audit");
const date_1 = require("../../utils/date");
const describe = (entry) => {
    const details = entry.details && Object.keys(entry.details).length > 0 ? ` (${Object.entries(entry.details).map(([k, v]) => `${k}: ${String(v)}`).join(', ')})` : '';
    return `${entry.action}${details}`;
};
const AuditTrail = ({ subjectType, subjectId }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [entries, setEntries] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        let cancelled = false;
        (0, audit_1.listAudit)(subjectType, subjectId).then((data) => {
            if (!cancelled)
                setEntries(data.collection);
        });
        return () => {
            cancelled = true;
        };
    }, [subjectType, subjectId]);
    if (entries.length === 0) {
        return (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-muted-foreground", children: t('components.AuditTrail.empty') });
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col", children: entries.map((entry, index) => ((0, jsx_runtime_1.jsxs)("div", { className: (0, cn_1.cn)('flex gap-2.5 py-2.5', index > 0 && 'border-t'), children: [(0, jsx_runtime_1.jsx)("span", { className: "mt-1.5 size-[7px] shrink-0 rounded-full bg-primary" }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "text-xs", children: describe(entry) }), (0, jsx_runtime_1.jsx)("div", { className: "mt-0.5 font-mono text-[10.5px] text-muted-foreground", children: (0, date_1.formatJst)(entry.at) })] })] }, String(entry._id)))) }));
};
exports.AuditTrail = AuditTrail;
